import moment from 'moment';
import { ESubtractType, availableDateFormats } from './date-format.constant';

export const MAXIMUM_MONEY_LENGTH = 13;

export function formatDateForDatePicker(value: string) {
    return value ? moment(value).format(availableDateFormats[0]) : '';
}

export function formatSubtractDate(value?: string, number?: number, type?: ESubtractType) {
    if (!number && !type) {
        return value
            ? moment(value).format(availableDateFormats[0])
            : moment().format(availableDateFormats[0])
    }
    return value
        ? moment(value).subtract(number, type).format(availableDateFormats[0])
        : moment().subtract(number, type).format(availableDateFormats[0])
}

export function removeComma(value: any): number {
    if (!value) {
        return 0;
    }
    return Number(value.toString().replace(/,/g, ''));
}

export function handlingErrMsg(responseError: ErrorEvent): string {
    if (!responseError) {
        return '';
    }
    const error = responseError.error;
    let message = '';
    if (error && error.Message) {
        message = error.Message;
    } else {
        error.detail?.forEach((d) => {
            message += `<div>${d.loc.toString() + ' ' + d.msg}</div>`
        })
    }
    return message;
};
